export const SERVICE_NAME: string = 'Logging service'
